// extracted by mini-css-extract-plugin
export default {"task-reward-form":"task-reward-form_ovAD3"};